<template>
  <PageContainer>
    <div class="flex flex-col align-center">
      <img src="@/assets/illustrations/benefit_analysis.svg" class="max-w-96 p-8">
      <h2>Improve your sleep, for good.</h2>
      <p>Accurate analysis and personalised coaching to build lasting habits.</p>
      <button @click="goToSignup()">Get Started</button>
      <button @click="goToLogin()" class="button-secondary">Log In</button>  
    </div>
  </PageContainer>
</template>

<script>
import PageContainer from '@/components/PageContainer'
import Cookie from '@/helpers/cookies'

export default {
  name: 'LandingPage',
  components: {
    PageContainer,
  },
  data() {
    return {
    }
  },
  beforeMount() {
  },
  methods: {
    goToSignup() {
      // Clear all cookies and browser storage.
      localStorage.clear()
      sessionStorage.clear()
      Cookie.clear()

      this.$router.push('/onboarding/name')
    },
    goToLogin() {
      this.$router.push('/login')
    },
  },
}
</script>